import commonApiService from "./common-api-service";

export default class enumService {
  static Get = async () => {
    return await commonApiService.getEnumerations();
  };
}
